import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaCaretDown } from "react-icons/fa";
import { setStoreData } from "../../core/redux/filters/filter.action.jsx";

const FilterStores = () => {
  const { stores } = useSelector((state) => state.stores);
  const { filter } = useSelector((state) => state.filter);
   const translation = useSelector((state) => state.root.translation);
  const { selectedLocationStore } = filter;
  const [storeList, setStoreList] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    const getStoreData = () => {
      const data = stores?.stores;
      return data?.map((store) => {
        return {
          label: store.storeCode + " -  " + store.name,
          value: store.storeCode,
        };
      });
    };
    setStoreList(getStoreData());
  }, [stores]);

  

  const handleCheckboxChange = (value) => {
    setSelectedStores((prevselectedStores) =>
      prevselectedStores.includes(value)
        ? prevselectedStores.filter((key) => key !== value)
        : [...prevselectedStores, value]
    );
  };

  const handleSelectAllChange = () => {
    if (selectedStores.length === storeList.length) {
      setSelectedStores([]);
    } else {
      const list = storeList?.map((store) => {
        return store.value;
      });
      setSelectedStores(list);
    }
  };
  const showDropDown = () => {
    setIsOpen(!isOpen);
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const filteredStores = storeList?.filter((store) =>
    store.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    setSelectedStores(selectedLocationStore);
  }, [selectedLocationStore]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, []);

  const cancel = () => {
    setSelectedStores(selectedLocationStore);
    setIsOpen(false);
  };

  const submit = () => {
    console.log('selectedStores',selectedStores);
    dispatch(setStoreData({ selectedLocationStore: selectedStores }));
    setIsOpen(false)
  };

  return (
    <div ref={dropdownRef} className=" dropdown select-store-dropdown">
      <div
        className="dropdown-toggle nav-link select-store"
        onClick={showDropDown}
      >
        <span className="user-name">
          <i className="fas fa-store"></i> {translation?.stores || "Stores"} {" "}
          {`(${selectedStores?.length})`} <FaCaretDown />
        </span>
      </div>
      <div
        className={
          "dropdown-menu dropdown-menu-right" + (isOpen ? " show" : "")
        }
      >
        <div className="dropdown-header">
          <input
            type="text"
            className="form-control"
            placeholder="Search Store"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
        <div className="stores-scroll">
          <div className="dropdown-item custom-label">
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={selectedStores?.length === storeList?.length}
                onChange={handleSelectAllChange}
                className="me-2"
              />
              {translation?.all || "All"}
            </label>
          </div>
          {filteredStores &&
            filteredStores.map((item) => (
              <div key={item.value} className="dropdown-item custom-label">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={selectedStores?.includes(item.value)}
                    onChange={() => handleCheckboxChange(item.value)}
                    className="me-2"
                  />
                  {item.label}
                </label>
              </div>
            ))}
        </div>
        <div className="d-flex justify-content-center button-container">
          <button
            className="btn btn-primary-light m-2"
            onClick={cancel}
          >
            {translation?.cancel || "Cancel"}
            
          </button>
          <button
            className="btn btn-primary m-2"
            disabled={!selectedStores || !selectedStores.length}
            onClick={submit}
          >
            {translation?.apply || "Apply"}
            
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterStores;
